<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 29 29"
    xml:space="preserve"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <use
      :id="`loading-image-background-${uniqueID}`"
      :xlink:href="`#loading-image-${uniqueID}`"
      x="0.5"
      y="0.5"
      width="56px"
      height="56px"
    />
    <defs>
      <image
        :id="`loading-image-${uniqueID}`"
        width="28px"
        height="28px"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACuklEQVRIia2WyWtUQRCHv99MojEuCUSNcckiuCAeRHBHQQRRLx48qCC44h/g0ZPgv6AS8CBEvIgXvXuQIHoRFCSCoocomLgTY6ITMz8PryfpeZkZzJsUPF5XV3V9r3qpfpBBbG+3vSfL2Cyw656Wu3MdfK/tK7YPBH2pZ0pPsDXbXmK7ISvssO1h25/DcywELUSwou3ltltsd4WnsxY0V4N5JGU/JGkMuASMAmPAZUmfgIWRn1J6mdRK/3VKHwCQdM12L5CTVAi2CaAx8i1QRcqAtluALcBLoBdoAfYBj4AbUylIf1Nxvod3I0n247aXAc3AN0k/p8ZGsA1AH7AYGAfOSXpR7Utrie0OYGVJBV5LGoXyNToTYAALgJNZYEFaoraA1pISA0dSg77WAfyV0kdneNhus91ne8D2HdsrstJs52yvtr3Odltsi9dwEcl8FyWNZ4VVgOeBfGlHK3ReBE4BReCmpDtzBOsENgbOoKRXOdtdAQbJmp633TwHMAHrmZ7FTtutOSBfwb9WBfpfUaXOnKR3wP2o73bpzNRFk4rA26hrSNKPKS0U4aX1gtJie57tBSU9Lm0TwFnb3UA/cE+Ss0KAHUA7MAQ8KdnitToN7AFWASeAXVlgQTYBXUAT0A1srgRsTw1aXgdwUUovlcwy4OOo/Qd4XgfwLcmZJrzflAxlW9f2VqCHZM6/APuBNuBp2M1VxXYTydTlgVfhvYxkd07V6YpnJQS4AGwL6gRwVdJwsOUBJE1G/seBjqCOAH0V7s2aN/7GqN0IrAWGbe8EDgI52w8l9Yc63BH5LwnZfUwHrVVR4imcBN7bnk/yrzM/fMShABsDfkT+Bab/AsqkVoa3gKMkl2e/pA/hAKdLYYOkou0HwO6QxDNJvysFrbqG1cT2UWB7UAdme7PMGhiga0gyGZxtNfoH1cJZ985rQkwAAAAASUVORK5CYII="
      />
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'IconLoading',
    props: {
      width: {
        type: [String, Number],
        default: 24,
      },
      height: {
        type: [String, Number],
        default: 24,
      },
    },
    data: () => ({
      uniqueID: null,
    }),
    created() {
      this.uniqueID = Date.now();
    },
  };
</script>
